import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface LoaderProps {
  size?: number;
  label?: string | null;
  loading?: boolean;
}
export function Loader({size = 50, label = null, loading = true}: LoaderProps) {
  if (!loading) {
    return null;
  }

  return (
    <Stack
      flex={1}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <LoaderSpinner size={size} />
      {label != null && <Typography py={1}>{label}</Typography>}
    </Stack>
  );
}

function LoaderSpinner({size}: {size: number}) {
    return <CircularProgress size={size} />;
}
